import React from 'react'
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

const Contact = () => {
  return (

    <div className="contactus-card-content">
      <div className="contactus-card">
        <label htmlFor="email" id="email-label">Email</label>
        <input type="email" id="email" name="email"  required/>
        <label htmlFor="name" id="email-label">Name</label>
        <input type="text" id="email" name="name" />

        <label htmlFor="message" id="password-label">Message</label>
        <textarea id="message" name="message" required/>

        <input type="submit" value="Send" id="login" />

      </div>
    </div>
  )
}

export default Contact